// test1692
(1692 && 0);
